// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import AdditionalAntennaRow from './AdditionalAntennaRow'
import antennaIcon from 'images/antenna-icon-orange.png'

const triggerStyles = {
  height: 18,
  width: 18,
}

// tooltipData is an array of additional antennas for the segment end of interest.

const AdditionalAntennaTooltip = ({ tooltipData, idRoot }) => (
  <dl className={'bg-white'}>
    <dt className={'display-flex'}>
      <img
        src={antennaIcon}
        style={triggerStyles} />
      <strong className={'heading-font'}>
        {`Additional Antenna${tooltipData.length > 1 ? 's' : ''}`}
      </strong>
    </dt>
    {tooltipData.map((d, i) => (
      <AdditionalAntennaRow
        {...d}
        key={d.segmentEndAntennaId}
        idRoot={`${idRoot}additional-${i}-`} />
    ))}
  </dl>
)

AdditionalAntennaTooltip.propTypes = {
  idRoot: string.isRequired,
  tooltipData: array.isRequired,
}

export default AdditionalAntennaTooltip
